module.exports = __webpack_public_path__ + "static/logo_slide-9e671922fbd133e8251247e825c281c6.png";